import { NgModule } from "@angular/core";

import { FlexLayoutModule } from "@angular/flex-layout";

import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { MenuComponent } from "./menu/menu.component";
import { OrderByPipe } from "./pipes/order-by.pipe";
import { ProductService } from "./services/product.service";
import { CartService } from "./services/cart.service";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { BannersComponent } from "./banners/banners.component";
import { HeaderTwoComponent } from "./header-two/header-two.component";
import { ShoppingWidgetsComponent } from "./shopping-widgets/shopping-widgets.component";
import { HeaderThreeComponent } from "./header-three/header-three.component";
import { BannersFourComponent } from "./banners-four/banners-four.component";
import { BlogSectionComponent } from "./blog-section/blog-section.component";
import { BannerPromotionComponent } from "./banner-promotion/banner-promotion.component";
import { HeaderFourComponent } from "./header-four/header-four.component";
import { CategoriesMenuComponent } from "./categories-menu/categories-menu.component";
import { CategoriesSectionComponent } from "./categories-section/categories-section.component";
import { FooterTwoComponent } from "./footer-two/footer-two.component";
import { HeaderFiveComponent } from "./header-five/header-five.component";
import { NombreMonedaPipe } from "./pipe/nombre-moneda.pipe";
import { PadstartPipe } from "./pipe/padstart.pipe";
import { MapMeeComponent } from "./map-mee/map-mee.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BlogSectionGroupSixComponent } from "./blog-section-group-six/blog-section-group-six.component";
import { SwiperModule } from "ngx-swiper-wrapper";
import { MarcasCarouselComponent } from "./marcas-carousel/marcas-carousel.component";
import { FilialCarouselComponent } from "./filial-carousel/filial-carousel.component";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import {
  MatButtonModule,
  MatCardModule,
  MatChipsModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSnackBarModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
} from "@angular/material";

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    SidebarComponent,
    OrderByPipe,
    BannersComponent,
    HeaderTwoComponent,
    ShoppingWidgetsComponent,
    HeaderThreeComponent,
    BannersFourComponent,
    BlogSectionComponent,
    BannerPromotionComponent,
    HeaderFourComponent,
    CategoriesMenuComponent,
    CategoriesSectionComponent,
    FooterTwoComponent,
    HeaderFiveComponent,
    NombreMonedaPipe,
    PadstartPipe,
    MapMeeComponent,
    BlogSectionGroupSixComponent,
    MarcasCarouselComponent,
    FilialCarouselComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatListModule,
    MatSliderModule,
    MatExpansionModule,
    MatMenuModule,
    MatTableModule,
    MatRadioModule,
    MatDialogModule,
    MatChipsModule,
    MatInputModule,
    MatIconModule,
    MatSidenavModule,
    MatSelectModule,
    MatTabsModule,
    MatDividerModule,
    MatCardModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
  ],
  exports: [
    CommonModule,
    MatButtonModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatListModule,
    MatExpansionModule,
    MatMenuModule,
    MatTableModule,
    MatSliderModule,
    MatRadioModule,
    MatDialogModule,
    MatChipsModule,
    MatInputModule,
    MatIconModule,
    MatSidenavModule,
    MatSelectModule,
    MatTabsModule,
    MatDividerModule,
    MatCardModule,
    OrderByPipe,
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    SidebarComponent,
    BannersComponent,
    FlexLayoutModule,
    HeaderTwoComponent,
    HeaderThreeComponent,
    HeaderFourComponent,
    HeaderFiveComponent,
    ShoppingWidgetsComponent,
    BannersFourComponent,
    BlogSectionComponent,
    BlogSectionGroupSixComponent,
    BannerPromotionComponent,
    CategoriesMenuComponent,
    CategoriesSectionComponent,
    FooterTwoComponent,
    MarcasCarouselComponent,
    FilialCarouselComponent,
  ],
  providers: [ProductService, CartService],
})
export class SharedModule {}
